import { Routes, Route, useLocation } from "react-router-dom";
import Loader from "./components/loader/loader";
import MainPage from "./components/main-page/main-page";
import Barrier from "./components/barrier/barrier/barrier";
import UZIP from "./components/UZIP/UZIP";
import Catalog from "./components/catalog/catalog";
import { usePreloadedImages } from "./contexts/PreloadedImagesContext";
import { AppHeaderUI } from "./components/ui/app-header/app-header";
import { useEffect } from "react";
import { ScrollToTop } from "./utils/scroll-to-top/ScrollToTop";

function App() {
  const { isLoaded } = usePreloadedImages();
  const location = useLocation();

  useEffect(() => {
    // Устанавливаем цвет фона: белый для /uzip, чёрный для всех остальных
    if (location.pathname === "/uzip") {
      document.body.style.backgroundColor = "white";
      // TODO: исправить условие
    } else if (location.pathname === "/catalog" || location.pathname === "/catalog/") {
      document.body.style.backgroundColor = "rgb(190, 190, 190)";
    } else {
      document.body.style.backgroundColor = "black";
    }
  }, [location]);

  return (
    <div className="App">
      <AppHeaderUI />
      {!isLoaded && <Loader />}
      {isLoaded && (
        <>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/barriers" element={<Barrier />} />
            <Route path="/uzip" element={<UZIP />} />
          </Routes>
        </>
      )}
    </div>
  );
}

export default App;
